const urls = {

    API_ROOT: process.env.REACT_APP_API_ROOT,
    NODE_ROOT: process.env.REACT_APP_NODE_ROOT

};

export default urls;



// WEBPACK FOOTER //
// ./src/utils/urls.js